import { render, staticRenderFns } from "./ColorSizeRoasModal.vue?vue&type=template&id=3ce4ca49&scoped=true&"
import script from "./ColorSizeRoasModal.vue?vue&type=script&lang=js&"
export * from "./ColorSizeRoasModal.vue?vue&type=script&lang=js&"
import style0 from "./ColorSizeRoasModal.vue?vue&type=style&index=0&id=3ce4ca49&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce4ca49",
  null
  
)

export default component.exports